// 這是Webpack掛載起始點
import Layout from './layout.vue'
import Index from '../.components/index.vue'
import New from '../.components/new.vue'
import Edit from '../.components/edit.vue'
import Print from '../.components/print.vue'

const main_router = 'assets'
const new_router = 'new_asset'
const edit_router = 'edit_asset'
const print_router = 'print_asset'

const router = [
    {
        path: '',
        name: 'assets',
        meta: {
            api_name: "api_v1_provider_assets",
            breadcrumb: [main_router],
            btns: [new_router]
        }
    },
    {
        path: 'index/:category/:page?',
        component: Index,
        name: 'assets_index',
        meta: {
            breadcrumb: [main_router]
        }
    },
    {
        path: 'new',
        component: New,
        name: 'new_asset',
        meta: {
            api_name: "api_v1_provider_asset_create",
            breadcrumb: [main_router, new_router]
        }
    },
    {
        path: 'edit/:id',
        component: Edit,
        name: 'edit_asset',
        meta: {
            api_name: "api_v1_provider_asset_update",
            breadcrumb: [main_router, edit_router]
        }
    },
    {
        path: 'print/:category/:page?',
        component: Print,
        name: 'print_asset',
        meta: {
            breadcrumb: [main_router, print_router]
        }
    },
]

export default router
